import { render, staticRenderFns } from "./AddReactivationTokenModal.container.vue?vue&type=template&id=68c9b470&"
import script from "./AddReactivationTokenModal.container.vue?vue&type=script&lang=ts&"
export * from "./AddReactivationTokenModal.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports